import { Offer as OfferAPI } from '@occc-app/Activate/apiTypes';

import { GetStarted } from './types';

type DeserializeOffer = (offerBody: OfferAPI) => GetStarted;
export const deserializeOffer: DeserializeOffer = (offerBody) => {
  return {
    category: offerBody.attributes.category,
    externalId: offerBody.attributes.external_id,
    name: offerBody.attributes.name,
    offerDescription: offerBody.attributes.description,
  };
};
